import React from 'react'
import { withIcon } from '../../withIcon'

function ArrowTopRightIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.2258 6.8387C7.2258 6.48239 7.51465 6.19354 7.87096 6.19354H17.1613C17.5176 6.19354 17.8064 6.48239 17.8064 6.8387V16.129C17.8064 16.4853 17.5176 16.7742 17.1613 16.7742C16.805 16.7742 16.5161 16.4853 16.5161 16.129V8.39626L7.2949 17.6175C7.04295 17.8694 6.63446 17.8694 6.38251 17.6175C6.13055 17.3655 6.13055 16.957 6.38251 16.7051L15.6037 7.48387H7.87096C7.51465 7.48387 7.2258 7.19502 7.2258 6.8387Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ArrowTopRightIcon)
